const FeaturedDirector = [
  {
    Name: 'Steven Spielberg',
    img: 'steven.jpg',
    description: 'Steven Allan Spielberg KBE is an American film director, producer, and screenwriter. A major figure of the New Hollywood era and pioneer of the modern blockbuster, he is the most commercially successful director of all time.',
  },
];

export default FeaturedDirector;
